import { Row } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import Skeleton from 'react-loading-skeleton'
import { logout } from 'utils/logout'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function AccountManagerBar({ ...props }) {
	const { accountManager } = useContext(CoreAdoptionContext)
	return (
		<Row id={formatSectionId(props)}>
			<div className="relative flex w-full justify-center bg-white px-4 py-4">
				{accountManager?.user_role.access_level === 3 ? (
					<div className="flex flex-col text-center md:flex-row md:text-left">
						<span className="mr-4">American Reading Company</span>
						<span className="mr-4 hidden font-normal md:inline-block">|</span>
						<span className="mr-4 font-bold">
							<a href="mailto:customercare@americanreading.com" className="font-normal">
								customercare@americanreading.com
							</a>
							<span className="ml-4 hidden font-normal md:inline-block">|</span>
						</span>
						<span className="font-bold">
							<a href="tel:8668102665" className="font-normal">
								(866) 810-2665
							</a>
						</span>
					</div>
				) : (
					<div className="flex flex-col text-center md:flex-row md:text-left">
						<span className="mr-4 font-bold">
							Account Manager:{' '}
							<span className="font-normal">
								{accountManager ? accountManager.name : <Skeleton width={150} />} <span className="ml-4 hidden md:inline-block">|</span>
							</span>
						</span>
						<span className="mr-4 font-bold">
							Email:{' '}
							<a href={`mailto:${accountManager ? accountManager.email : ''}`} className="font-normal">
								{accountManager ? accountManager.email : <Skeleton width={200} />}
							</a>
							<span className="ml-4 hidden font-normal md:inline-block">|</span>
						</span>
						<span className="font-bold">
							Phone:{' '}
							<a href={`tel:${accountManager ? accountManager.phone : ''}`} className="font-normal">
								{accountManager ? accountManager.phone : <Skeleton width={120} />}
							</a>
						</span>
					</div>
				)}
				<div className="absolute hidden lg:block" style={{ right: 15, top: 11 }}>
					<button className="rounded border px-2 py-1 shadow-sm hover:bg-white hover:text-slate-800" onClick={logout}>
						Logout
					</button>
				</div>
				<div className="absolute top-4 right-4 block lg:hidden">
					<button className="text-slate-500" onClick={logout}>
						<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
							<path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
						</svg>
					</button>
				</div>
			</div>
		</Row>
	)
}
